import { ServiceProvider } from "@sa/rep-services-provider";
import { MapDataSourceId } from "../models/MapDataSource";
import { MapDataExtractorProvider } from "./MapDataExtractorsProvider";
import { MapExportQueryBuilderProvider } from "./MapExportQueryBuilderProvider";
import { ServicesMaps } from "../MapReportingProvider";
import { HarmDataExtractor } from "./extractors/HarmExtractor";
import { UNComtradeExtractor } from "./extractors/UNComtradeExtractor";
import { AlternativeDatasetExtractor } from "./extractors/AlternativeDatasetExtractor";

export function registerDataExtractorsProvider(serviceProvider: ServiceProvider) {
  serviceProvider.transient(ServicesMaps.MapDataExtractorsProvider, () => {
    const provider = new MapDataExtractorProvider();
    provider.register(MapDataSourceId.HarmonizedDataset, new HarmDataExtractor(serviceProvider));
    provider.register(MapDataSourceId.UNComtrade, new UNComtradeExtractor(serviceProvider));
    provider.register(MapDataSourceId.USDA_PSD, new AlternativeDatasetExtractor(serviceProvider));
    provider.register(MapDataSourceId.OECD_FAO, new AlternativeDatasetExtractor(serviceProvider));
    provider.register(MapDataSourceId.USDAForecast, new AlternativeDatasetExtractor(serviceProvider));
    provider.register(MapDataSourceId.FAPRI, new AlternativeDatasetExtractor(serviceProvider));
    provider.register(MapDataSourceId.FAPRI2012, new AlternativeDatasetExtractor(serviceProvider));
    provider.register(MapDataSourceId.FAOProdStat, new AlternativeDatasetExtractor(serviceProvider));
    return provider;
  })
}

export function registerExportQueryBuildersProvider(serviceProvider: ServiceProvider) {
  serviceProvider.transient(ServicesMaps.MapExportQueryBuilderProvider, () => {
    const provider = new MapExportQueryBuilderProvider();
    provider.register(MapDataSourceId.HarmonizedDataset, new HarmDataExtractor(serviceProvider));
    provider.register(MapDataSourceId.UNComtrade, new UNComtradeExtractor(serviceProvider));
    provider.register(MapDataSourceId.USDA_PSD, new AlternativeDatasetExtractor(serviceProvider));
    provider.register(MapDataSourceId.OECD_FAO, new AlternativeDatasetExtractor(serviceProvider));
    provider.register(MapDataSourceId.USDAForecast, new AlternativeDatasetExtractor(serviceProvider));
    provider.register(MapDataSourceId.FAPRI, new AlternativeDatasetExtractor(serviceProvider));
    provider.register(MapDataSourceId.FAPRI2012, new AlternativeDatasetExtractor(serviceProvider));
    provider.register(MapDataSourceId.FAOProdStat, new AlternativeDatasetExtractor(serviceProvider));
    return provider;
  })
}